type JsonValue = string | number | boolean | null | JsonObject | JsonArray;

interface JsonObject {
  [key: string]: JsonValue;
}

type JsonArray = JsonValue[];

export function FormatarCpfCnpj<T extends JsonObject>(obj: T | string): T {
  const camposDeBusca = ["cpf", "cnpj", "identificacaocliente"];

  const objeto =
        typeof obj === 'object'
            ? JSON.parse(JSON.stringify(obj))
            : typeof obj === 'string' ? JSON.parse(obj) : obj;

  if (typeof objeto !== 'object') return objeto;

  function percorrer(valor: JsonValue): void {
    if (Array.isArray(valor)) {
      valor.forEach(percorrer);
      return;
    }

    if (valor && typeof valor === "object") {
      const registro = valor as JsonObject;

      for (const chave in registro) {
        const valorAtual = registro[chave];

        if (
          camposDeBusca.some((campo) => chave.toLowerCase().includes(campo)) &&
          ["string", "number"].includes(typeof registro[chave]) &&
          String(valorAtual).trim() !== ""
        ) {
          registro[chave] = String(valorAtual)
            .toUpperCase()
            .padStart(14, "0")
            .slice(-14);
        } else {
          percorrer(valorAtual);
        }
      }
    }
  }

  percorrer(objeto);

  return objeto;
}
